import { useState, useEffect } from 'react';
import axios from 'axios';
import { providersApi, ProviderWithUser } from '../services/providers';

export const useMyProvider = () => {
  const [provider, setProvider] = useState<ProviderWithUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchMyProvider = async () => {
      try {
        setLoading(true);
        const data = await providersApi.getMyProfile();

        // DEBUG: Log provider data to help diagnose checklist issues (development only)
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.log('=== useMyProvider DEBUG ===', {
            business_name: data.business_name,
            user_profile_image_url: data.user_profile_image_url,
            education: data.education,
            years_of_experience: data.years_of_experience,
            profile_completion_percentage: data.profile_completion_percentage,
          });
        }

        setProvider(data);
        setError(null);
      } catch (err: unknown) {
        if (axios.isAxiosError(err)) {
          if (err.response?.status === 404) {
            // User is not a provider
            setProvider(null);
            setError(null);
          } else {
            setError(err.message || 'Failed to fetch provider profile');
            console.error('Error fetching provider profile:', err);
          }
        } else if (err instanceof Error) {
          setError(err.message || 'An unexpected error occurred');
          console.error('Error fetching provider profile:', err);
        } else {
          setError('An unexpected error occurred');
          console.error('Error fetching provider profile:', err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMyProvider();
  }, []);

  return { provider, loading, error };
};
